export function getNonBillableTime(timeRegistered = 0, billableTimeRegistered = 0) {
    const nonBillableTime = timeRegistered - billableTimeRegistered;
    return nonBillableTime;
}
